/*******************************
 * Dismissables
 ******************************/

import { select } from '@js/util/select.js'

const dismissedClass = 'dismissed'
const initializedClass = 'initialized'

select('[data-dismissable]', element => {
  element.classList.add(initializedClass)

  const key = element.dataset.dismissable
  const localStorageKey = `dismissable-dismissed__${key}`
  const dismissButton = element.querySelector('.dismiss-button')

  const isDismissed = Boolean(localStorage.getItem(localStorageKey))
  if (isDismissed) element.classList.add(dismissedClass)

  dismissButton?.addEventListener('click', () => {
    localStorage.setItem(localStorageKey, true)
    element.classList.add(dismissedClass)
  })
})
